import { dateRangeHumanLabel } from '../components/taskScheduleConstants'
import { triggerLabel } from './scheduledTaskDisplay'

export type SchedulePreviewValues = {
  schedule_type: string
  time: string
  timezone: string
  day_of_week?: number
  day_of_month?: number
  run_date?: string
  date_range_strategy?: string
}

function lowerFirst(label: string): string {
  if (!label) return label
  return label.charAt(0).toLowerCase() + label.slice(1)
}

/**
 * One-sentence next-run preview for create/edit/install.
 * Combines triggerLabel copy with timezone and a human date-range label.
 */
export function buildSchedulePreview(values: SchedulePreviewValues): string {
  const trigger = triggerLabel({
    schedule_type: values.schedule_type,
    schedule_config: {
      time: values.time,
      day_of_week: values.day_of_week,
      day_of_month: values.day_of_month,
      run_date: values.run_date,
    },
  })

  const tz = String(values.timezone || '').trim()
  const tzPart = tz ? ` ${tz}` : ''

  const rangeLabel = dateRangeHumanLabel(values.date_range_strategy)
  const rangePart = rangeLabel ? ` · analyzes ${lowerFirst(rangeLabel)}` : ''

  return `${trigger}${tzPart}${rangePart}`
}
